import { ActionButton, Error } from "@eisox/design-system";
import { Link } from "@tanstack/react-router";

import { m } from "~/paraglide/messages";

export const NotFound: React.FC = () => (
  <Error.Root>
    <Error.Title>404</Error.Title>
    <Error.Description>{m["404"]()}</Error.Description>
    <ActionButton asChild>
      <Link to={"/buildings"}>{m.my_buildings()}</Link>
    </ActionButton>
  </Error.Root>
);
